import { getBaseUrl } from './ServiceUtils';
import appRequest from './appRequest';

const AUTH_URL = getBaseUrl();

export async function doLogin(email, password) {
    return await appRequest.doPostRequest(`${AUTH_URL}/login`, {email, password});
}

export async function doLogout() {
    return await appRequest.doPostRequest(`${AUTH_URL}/logout`, {});
}

export async function changeExpiredPassword(email, currentPassword, newPassword) {
    return await appRequest.doPostRequest(`${AUTH_URL}/changeExpiredPassword`, { email, currentPassword, newPassword });
}

export async function doRefresh() {
    return await appRequest.doPostRequest(`${AUTH_URL}/refresh`, {});
}